import ersLogin from '@components/login/m1_login.vue'
import ersLogined from "@components/logined/m1_logined.vue";
export default {
    data: function () {
        return {
            user: {},
            testInforms: [],
            tipNoticeList: [],
            tipNoticeNum: 0,
            dialogVisible: false,
            tipDialogVisible: false,
            totalCount: "",
            one_notice: {
                content: '',
                title: '',
                proc_id: ''
            },
            haveTip: false,
            this_notice: {
                content: '',
                title: '',
                proc_id: ''
            },
            isMobile: false,
            testTotalCount:"",
            domain: this.$route.params.projectCode||this.$store.state.examInfo.currentExamInfo.domain,     }
    },
    created: function () {
        var ua = navigator.userAgent;
        var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
            isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
            isAndroid = ua.match(/(Android)\s+([\d.]+)/);
        this.isMobile = isIphone || isAndroid;
        this.$store.commit('setHeaderState', '1');
    },
    components: {
        'ersLogin': ersLogin,
        'ersLogined': ersLogined,
    },
    computed: {
        userName: function () {
            if (this.$store.state.common.currentUser == null) {
                this.$http.get(globalProvider.serviceUrl('pc/g'))
                    .then((data) => {
                        if (data.body.code == resultCode.Success) {
                            this.$store.commit('setCurrentUser', data.body.data);
                            return this.$store.state.common.currentUser.name
                        }
                    });
            } else {
                return this.$store.state.common.currentUser.name
            }
        },
        loginInform: function () {
            this.user = this.$store.state.common.token;
            return !this.user;
        },
        api_state: function () {
            return this.$store.state.examInfo.currentExamInfo.api_state;
        },
        user_type: function () {
            if (this.$store.state.common.userType != null) {
                if (this.$store.state.common.userType.if_bind_user && this.$store.state.common.token != null) {
                    this.getNoReadTipAnnouncement();
                }
                if (this.$store.state.common.userType.if_bind_user && this.$store.state.common.currentUser == null) {
                    this.$http.get(globalProvider.serviceUrl('pc/g'))
                        .then((data) => {
                            if (data.body.code == resultCode.Success) {
                                this.$store.commit('setCurrentUser', data.body.data);
                            }
                        });
                }
            }
            return this.$store.state.common.userType
        }
    },
    watch: {
        api_state: function (curVal, oldVal) {
            if (this.$store.state.examInfo.currentExamInfo.api_state) {
                this.getData();
            }
        },
        tipNoticeNum(curVal, oldVal) {
            this.getAnnouncement(this.tipNoticeList[curVal], 'tip')
        },
    },
    methods: {
        getNormalAnn: function (captcha_token) {
            let url;
            if(this.$route.params.batchCode){
                url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/BATCH/'+this.$route.params.batchCode;
            }else{
                url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/PROJECT';
            }
            this.$http.get(globalProvider.serviceUrl(url), {
                    params: {
                        domain: this.$route.params.projectCode,
                        page_index: 1,
                        page_size: 5,
                        n_type: 'se'
                    },
                    headers: {
                        ttoken: captcha_token
                    },
                    emulateJSON: false
                })
                .then((data) => {
                    if (data.body.code == resultCode.Success) {
                        data.body.data.map(item => {
                            if (item.type == 1) {
                                this.testInforms = item._items;
                                this.testTotalCount = item.totalCount;
                            }
                        });
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message), '提示', {
                            confirmButtonText: '确定'
                        });
                    }
                })
        },
        set_captcha_token: function (callback) {
            this.$http.get(globalProvider.serviceUrl('ea/tt'))
                .then((data) => {
                    if (data.body.code == resultCode.Success) {
                        callback(data.body.data)
                    }
                })
        },
        getTipAnnouncement: function (captcha_token) {
            let url;
            if(this.$route.params.batchCode){
                url = 'ea/g/tnis/{domain}/se/BATCH/'+this.$route.params.batchCode;
            }else{
                url = 'ea/g/tnis/{domain}/se/PROJECT';
            }
            this.$http.get(globalProvider.serviceUrl(url), {
                    params: {
                        domain: this.$route.params.projectCode,

                    },
                    headers: {
                        ttoken: captcha_token
                    },
                    emulateJSON: false
                })
                .then((data) => {
                    if (data.body.code == resultCode.Success) {
                        if (data.body.data.length > 0) {
                            this.tipNoticeList = data.body.data;
                            this.tipDialogVisible = true;
                            this.getAnnouncement(this.tipNoticeList[0]);
                        }
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message), '提示', {
                            confirmButtonText: '确定'
                        });
                    }
                })
        },
        getNoReadTipAnnouncement: function () {
            let url;
            if(this.$route.params.batchCode){
                url = 'ea/g/utnis/BATCH/'+this.$route.params.batchCode;
            }else{
                url = 'ea/g/utnis/PROJECT';
            }
            if (!this.haveTip) {
                this.$http.get(globalProvider.serviceUrl(url))
                    .then((data) => {
                        if (data.body.code == resultCode.Success) {
                            if (data.body.data.length > 0) {
                                this.tipNoticeList = data.body.data;
                                this.haveTip = true
                                this.tipDialogVisible = true;
                                this.getAnnouncement(this.tipNoticeList[0]);
                            }
                        } else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(getErrorMessage(data.body.message), '提示', {
                                confirmButtonText: '确定'
                            });
                        }
                    })
            }
        },
        getAnnouncement: function (notice_id, id) {
            if (id === 'normal') {
                document.getElementsByClassName('notice-dialog-body').scrollTop = 0;
                this.dialogVisible = true;
                this.$http.get(globalProvider.serviceUrl('ea/g/nts/d/{notice_id}'), {
                        params: {
                            notice_id: notice_id,
                        },
                    })
                    .then((data) => {
                        if (data.body.code == resultCode.Success) {
                            this.one_notice = data.body.data;
                        } else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(getErrorMessage(data.body.message), '提示', {
                                confirmButtonText: '确定'
                            });
                        }
                    })
            } else {
                this.$http.get(globalProvider.serviceUrl('ea/g/nts/d/{notice_id}'), {
                        params: {
                            notice_id: notice_id,
                        },
                    })
                    .then((data) => {
                        if (data.body.code == resultCode.Success) {
                            this.this_notice = data.body.data;
                        } else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(getErrorMessage(data.body.message), '提示', {
                                confirmButtonText: '确定'
                            });
                        }

                    })
            }
        },
        getData() {
            if (this.$store.state.common.token != null) {
                this.getNormalAnn();
            } else {
                this.set_captcha_token(this.getNormalAnn);
                this.set_captcha_token(this.getTipAnnouncement);
            }
        },
    }
}